"use strict";

/**
 * DateUtil
 */
module.exports = {

	/**
	 * @param  {String} date_str waiting format :yyyy-MM-dd
	 * @return {Date}
	 */
	dateFactory: function (date_str) {
		if (!date_str) return null;
		var date_array = date_str.split("-");

		if (date_array.length == 3) {
			// ie n'a l'air d'accepter que le format 1900-01-01
			// contrairement à chrome et ff où on peut passer l'heure en plus avec T00:00:01+0000
			return new Date(Date.UTC(parseInt(date_array[0]), parseInt(date_array[1]) - 1, parseInt(date_array[2])));
		} else {
			return null;
		}
	},

	/**
	 * return last day of month
	 * @param  {Number} year  [description]
	 * @param  {Number} month 1-12
	 * @return {Number}       [description]
	 */
	lastDay: function (year, month) {
		var d = new Date(Date.UTC(year, month, 0)); // month - one day
		return d.getUTCDate();
	},

	/**
	 * Make dates ranges between a min and max date, using N years interval.
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval   number of years
	 * @return {Array}            "from" included, "to" not included.
	 */
	splitYears: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str),
			year_start = date_start.getUTCFullYear(),
			year_end = date_end.getUTCFullYear() + 1;

		year_start = Math.floor(year_start / interval) * interval;
		year_end = Math.ceil(year_end / interval) * interval;

		while (year_start < year_end) {
			ret.push({
				from: year_start + "-01-01",
				to: (year_start + interval) + "-01-01"
			});
			year_start += interval;
		}

		return ret;
	},

	/**
	 * Make dates ranges between a min and max date, using N months intervals.
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval       Number of months
	 * @return {[type]}                [description]
	 */
	splitMonths: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str);

		date_start.setUTCDate(1); // first day of month
		date_end.setUTCMonth(date_end.getUTCMonth() + 1, 1); // first day of next month

		while (date_start < date_end) {
			var next_month = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth() + interval, 1));
			ret.push({
				from: date_start.getUTCFullYear() + "-" + (date_start.getUTCMonth() + 1) + "-" + date_start.getUTCDate(),
				to: next_month.getUTCFullYear() + "-" + (next_month.getUTCMonth() + 1) + "-" + next_month.getUTCDate()
			});
			date_start.setUTCMonth(date_start.getUTCMonth() + interval);
		}

		return ret;
	},

	/**
	 * Make dates ranges between a min and max date, using 7 days interval, grouped by month.
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval       Number of weeks
	 * @return {[type]}                [description]
	 */
	splitWeeks: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str);

		date_start.setUTCDate(1); // first day of month
		date_end.setUTCMonth(date_end.getUTCMonth() + 1, 1); // first day of next month next

		while (date_start < date_end) {
			var next_week = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth(), date_start.getUTCDate() + (interval * 7)));
			if (date_start.getUTCMonth() != next_week.getUTCMonth()) {
				next_week = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth() + 1, 1));
			}
			ret.push({
				from: date_start.getUTCFullYear() + "-" + (date_start.getUTCMonth() + 1) + "-" + date_start.getUTCDate(),
				to: next_week.getUTCFullYear() + "-" + (next_week.getUTCMonth() + 1) + "-" + next_week.getUTCDate()
			});
			date_start = new Date(next_week);
		}

		return ret;
	},

	/**
	 * Make dates ranges between a min and max date, using 1 days interval
	 * Useful for date range aggregation.
	 * @param  {String} date_start_str "yyyy-MM-dd"
	 * @param  {String} date_end_str   "yyyy-MM-dd"
	 * @param  {Number} interval       Number of days
	 * @return {[type]}                [description]
	 */
	splitDays: function (date_start_str, date_end_str, interval) {
		var ret = [],
			date_start = this.dateFactory(date_start_str),
			date_end = this.dateFactory(date_end_str);
		date_end.setUTCDate(date_end.getUTCDate() + 1);

		while (date_start < date_end) {
			var next_day = new Date(Date.UTC(date_start.getUTCFullYear(), date_start.getUTCMonth(), date_start.getUTCDate() + interval));
			ret.push({
				from: date_start.getUTCFullYear() + "-" + (date_start.getUTCMonth() + 1) + "-" + date_start.getUTCDate(),
				to: next_day.getUTCFullYear() + "-" + (next_day.getUTCMonth() + 1) + "-" + next_day.getUTCDate()
			});
			date_start.setUTCDate(date_start.getUTCDate() + interval);
		}

		return ret;
	}

};